import React from 'react';

import Select from 'react-select';

import sireReviewVersion from '@/data/sireReviewVersion';
import { getCustomStyles } from '@/utils/customStyleSelect';

const SelectReviewVersion: React.FC<any> = ({ name, value, defaultValue, handleChange, placeholder, hasError, isDisabled }) => {
    return (
        <Select
            name={name}
            value={sireReviewVersion.find((option: any) => option.value === value)}
            onChange={handleChange}
            options={sireReviewVersion}
            defaultValue={defaultValue}
            placeholder={placeholder}
            styles={getCustomStyles(hasError)}
            isDisabled={isDisabled}
        />
    );
};

export default SelectReviewVersion;
